import {AdvertisementType} from '../../utilities/helper/unitGenerator/unit.types';
import {restrictedStoreInputGroups} from '../config/restrictedStoreInputGroups';
import {StoreAccountPlanType} from '../constants/storeType';

interface IRestrictedInputGroups {
  advertisementType: AdvertisementType;
  storePlanType: StoreAccountPlanType;
  adType: 'personal' | 'store';
}

export function getRestrictedInputGroups({
  adType,
  advertisementType,
  storePlanType,
}: IRestrictedInputGroups) {
  if (adType === 'personal') return [];
  const allStorePlanInputGroups = restrictedStoreInputGroups[storePlanType];

  const targetInputGroups = allStorePlanInputGroups[advertisementType];

  return targetInputGroups ?? [];
}
